import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { makeStyles } from '@material-ui/core';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';

const useStyles = makeStyles((theme) => ({
  formRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  image: {
    width: '80%',
    height: '100%',
    margin: `${theme.spacing(2)}px auto`,
  },
}));

export default function CuratedContentArticleLayout() {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  const imageUrl = resource.relationship(fr.relationships.image.name)?.link('related').url();

  return (
    <div>
      <div className={classes.formRow}>
        <MetaField attr="categoryDisplayName" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="name" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="excerpt" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="lifeMilestoneId" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="topicId" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="contentUrl" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="minAge" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="maxAge" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="targetedHouseholdStatus" />
      </div>
      <div className={classes.formRow}>
        <MetaField attr="publishedDate" />
      </div>
      <div className={classes.formRow}>
        {imageUrl && <img src={imageUrl} className={classes.image} />}
      </div>
      <div className={classes.formRow}>
        <Typography color="darkGray">
          <em>{'Upload an image for this article by clicking the upload image icon from the table view after it has been created.'}</em>
        </Typography>
      </div>
    </div>
  );
}
